import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ResultComponent } from './result/result';
import { ResultDetailPageModule } from './result-detail/result-detail.module';

@NgModule({
  declarations: [
    ResultComponent
  ],
  imports: [
    ResultDetailPageModule,
    IonicPageModule.forChild(ResultModule),
  ],
  exports: [
    ResultComponent
  ]
})
export class ResultModule {}



// WEBPACK FOOTER //
// ./src/app/result/result.module.ts